"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var __jsx = _react.default.createElement;
var CaretDownIcon = function CaretDownIcon(props) {
  return __jsx(_Icon.default, (0, _extends2.default)({
    width: 20,
    height: 11
  }, props), __jsx("path", {
    d: "M10 11a2.222 2.222 0 01-1.446-.531L.776 3.871A2.186 2.186 0 01.535.768 2.243 2.243 0 013.669.53L10 5.9 16.331.53a2.239 2.239 0 013.134.238 2.186 2.186 0 01-.241 3.1l-7.778 6.6A2.222 2.222 0 0110 11z"
  }));
};
var _default = CaretDownIcon;
exports.default = _default;